import { render, staticRenderFns } from "./ResetPasswordRequest.vue?vue&type=template&id=3c89ec7a&scoped=true&"
import script from "./ResetPasswordRequest.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordRequest.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordRequest.vue?vue&type=style&index=0&id=3c89ec7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c89ec7a",
  null
  
)

export default component.exports